import React, {useState} from "react";
import useSWR from "swr";
import { Box, Button, TextField } from "@mui/material";
import { useParams } from "react-router-dom";
import HelloText from "../components/HelloText";
import QnaAnswer from "../components/QnaAnswer";
const QnaPage = () => {
  let params = useParams();
  const { data, error } = useSWR(
    process.env.REACT_APP_DEF_URL + "qnapage?qna_id=" + params.Id
  );
  
  if (error) return <div>failed to load</div>;
  if (!data) return <div>loading...</div>;
  return (
    <div>
      <HelloText />
      <Box
        sx={{
          "& > :not(style)": {
            m: 1,
            width: "80%",
            display: "flex",
            alignItems: "center",
          },
        }}
      >
        <TextField
          id="outlined-basic"
          label="İsim"
          variant={"outlined"}
          fullWidth
          disabled
          defaultValue={data.qna_name}
        />
        <TextField
          id="outlined-basic"
          label="Konu"
          variant={"outlined"}
          fullWidth
          disabled
          defaultValue={data.qna_title}
        />
        <TextField
          id="outlined-basic"
          label="Mesaj"
          variant={"outlined"}
          fullWidth
          disabled
          multiline
          defaultValue={data.qna_text}
        />
      </Box>
      <h2 style={{margin:"10px"}}>Cevap Yaz</h2>
     <QnaAnswer Id={data.qna_id} verify={data.qna_verify}/>
    </div>
  );
};

export default QnaPage;
